import { ComparableMetric, ListedMetric, MetricRequest } from '@core/models/metric.models'
import { Team } from '@core/models/team.models'
import { MetricDetailSubHeader } from '@features/metric-detail/models/metric-detail.models'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'

export const parseTeamToMetricDetailRequest = (
  context: Team,
  value: ListedMetric | ComparableMetric
): MetricRequest => ({
  seasonId: context.seasonId,
  competitionId: context.competitionId,
  teamId: context.id,
  metricKey: value.key
})

export const parseTeamMetricDetailSubHeader = (metricContext: Team): MetricDetailSubHeader => ({
  imageA: metricContext.portraitLogo,
  textA: metricContext.abbreviation,
  placeholderA: PLACEHOLDER_IMAGES.TEAM
})
